export default class Description {
	text: string;
	image: string;
	imageFile: File;
}
